export class Helper
{
    public static convertToMinorDenomination(value: any): number
    {
        if (value)
        {
            if (typeof value === 'number')
            {
                return Math.round(value * 100);
            }
            else if (typeof value === 'string')
            {
                const cleanedValue = this.removeCurrencyPrefix(value).replace(/,/g, '').trim();
                if (cleanedValue === '' || cleanedValue === undefined)
                {
                    return 0;
                }
                return Math.round(parseFloat(cleanedValue) * 100);
            }
        }
        else
        {
            return value;
        }
    }

    public static convertToMajorDenomination(value: number): number
    {
        return value / 100;
    }

    /**
     * Cleans a currency value by removing currency symbols and formatting, then converts it to a number.
     * Handles strings with currency prefix (e.g., "R ", "$ ", "€ ") and comma separators, as well as numbers.
     *
     * @param value - The value to clean (string, number, or other)
     * @returns A number representing the cleaned currency value, or 0 if the value is invalid/empty
     */
    public static cleanCurrencyValue(value: any): number
    {
        if (!value)
        {
            return 0;
        }
        if (typeof value === 'number')
        {
            return value;
        }
        const cleaned = typeof value === 'string'
            ? this.removeCurrencyPrefix(value).replace(/,/g, '').trim()
            : String(value);
        return parseFloat(cleaned || '0') || 0;
    }

    /**
     * Removes currency prefix from a string value.
     * Detects common currency prefixes (letters followed by optional space) at the start of the string.
     * Examples: "R 123" -> "123", "$ 123" -> "123", "€123" -> "123"
     *
     * @param value - The string value that may contain a currency prefix
     * @returns The string with currency prefix removed
     */
    private static removeCurrencyPrefix(value: string): string
    {
        return value.replace(/^[A-Za-z]+\s*/g, '').trim();
    }
}